export const TZ = "Asia/Dubai";
export const TZ_LABEL = "Dubai time · GST (UTC+4)";
const validTz = (tz) => {
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: tz });
    return !!tz;
  } catch (e) {
    return false;
  }
};
const detectedTz = (() => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    return null;
  }
})();
export const userTz = validTz(detectedTz) ? detectedTz : TZ;
export const isAbroad = userTz !== TZ;

export const tzShort = (iso, tz = userTz) =>
  new Intl.DateTimeFormat("en-US", { timeZone: tz, timeZoneName: "short" }).formatToParts(new Date(iso)).find((p) => p.type === "timeZoneName")?.value || "";

export const tzName = (tz = userTz) => tz.split("/").pop().replace(/_/g, " ");

export const localTzLabel = (iso = new Date().toISOString()) => (isAbroad ? `Your local time · ${tzName()} (${tzShort(iso)})` : TZ_LABEL);

export const ymdIn = (iso, tz) => {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date(iso));
  const get = (t) => parts.find((p) => p.type === t).value;
  return `${get("year")}-${get("month")}-${get("day")}`;
};

const clean = (s) => s.replace(/\u202f/g, " ");

export const fmtTime = (iso, tz = TZ) =>
  clean(new Intl.DateTimeFormat("en-US", { hour: "numeric", minute: "2-digit", hour12: true, timeZone: tz }).format(new Date(iso)));

export const fmtDateLong = (iso, tz = TZ) =>
  new Intl.DateTimeFormat("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric", timeZone: tz }).format(new Date(iso));

export const fmtDateShort = (iso, tz = TZ) =>
  new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: tz }).format(new Date(iso));

export const ymdToIso = (ymd) => `${ymd}T08:00:00Z`;
export const ymdLong = (ymd) => fmtDateLong(ymdToIso(ymd));
export const ymdShort = (ymd) => fmtDateShort(ymdToIso(ymd));

export const hmTo12 = (hm) => {
  const [h, m] = hm.split(":").map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};

export const dubaiToday = () => ymdIn(new Date().toISOString(), TZ);

export const addDays = (ymd, n) => {
  const d = new Date(`${ymd}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return ymd;
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

export const weekdayMon0 = (ymd) => (new Date(`${ymd}T00:00:00Z`).getUTCDay() + 6) % 7;

export const timeOptions = (step) => {
  const out = [];
  for (let t = 0; t < 24 * 60; t += step) {
    const hm = `${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`;
    out.push({ value: hm, label: hmTo12(hm) });
  }
  return out;
};

export const BUDGETS = ["$150,000–$250,000", "$250,000–$350,000", "$350,000–$500,000", "$500,000+", "Prefer not to say"];

export const STATUS_LABELS = { confirmed: "Confirmed", rescheduled: "Rescheduled", completed: "Completed", cancelled: "Cancelled" };

export const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
